import React from 'react';
import Button from '../../Button/Button';

function InsightsSection() {
  return (
        <section className="section-pad overflow-hidden insights md:mt-0 bg-[#080617] -mb-3">
             <div className="container mx-auto px-2 py-10">
                <div data-aos="fade-up">
                    <h3 className="text-center text-[350px] font-secondary font-bold text-[#080617] leading-[400px] hidden md:block">20%</h3>
                    <h2 className="font-main text-[#fff] text-[22px] md:text-[42px] text-center font-bold tracking-normal leading-[26px] md:leading-[46px] mx-auto w-full md:w-4/5 md:-mt-[130px] opacity-80">
                    Experience a 20% increase in lead conversion by using Vymo</h2>
                </div>

                <div className="flex flex-col lg:flex-row items-center lg:items-start gap-0 md:gap-4 mt-6 pb-[80px]">
                    <div className="text-center w-full md:w-1/3 px-2" data-aos="fade-up" data-aos-delay="200"> 
                        <h3 className="text-center text-[120px] font-secondary font-bold text-[#080617] leading-[140px]">38%</h3>
                        <p className="text-18 md:text-22 font-medium text-center text-[#e6e3ff] px-2 -mt-4 md:-mt-2 opacity-80">Increase in Lead Volume from Agency Engagement</p>
                    </div>
                    <div className="text-center w-full md:w-1/3 px-2 mt-6 md:mt-0" data-aos="fade-up" data-aos-delay="400">
                        <h3 className="text-center text-[120px] font-secondary font-bold text-[#080617] leading-[140px]">50%</h3>
                        <p className="text-18 md:text-22 font-medium text-center text-[#e6e3ff] px-2 -mt-4 md:-mt-2 opacity-80">Increase in Advisor Recruitment</p>
                    </div>
                    <div className="text-center w-full md:w-1/3 px-2 mt-6 md:mt-0" data-aos="fade-up" data-aos-delay="600">
                         <h3 className="text-center text-[120px] font-secondary font-bold text-[#080617] leading-[140px]">75%</h3>
                         <p className="text-18 md:text-22 font-medium text-center text-[#e6e3ff] px-2 -mt-4 md:-mt-2 opacity-80">Daily Active Usage</p>
                    </div>
                </div>

            </div>
        </section>
);
}

export default InsightsSection;